import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import MoreIcon from "@mui/icons-material/MoreVert";
import { useAuth } from "../../../../context/AuthProvider/useAuth";
import { useNavigate } from "react-router-dom";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import LogoutIcon from "@mui/icons-material/Logout";
import {
  Button,
  Divider,
  PopoverOrigin,
  SxProps,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  filteredTurismSecondary,
  generalWhite,
} from "../../../../styles/colors";
import { UserRole } from "../../../../types/types";
import { PrimaryButton } from "../../buttons/PrimaryButton";
import MobileMenuItem from "./MobileMenuItem";
import { useState } from "react";
import MenuItem from "./MenuItem";
import { handleLogout } from "../../../../utils/miscelaneous";
import BrandLogo from "@/components/general/BrandLogo";
import { sharedStyles } from "@/styles/shared";
import LuggageIcon from "@mui/icons-material/Luggage";

interface ClientNavbarProps {
  isUserComercial?: boolean;
  hideMidButton?: boolean;
  hideMenuButton?: boolean;
  hideCartButton?: boolean;
}

const anchorProps: PopoverOrigin = {
  vertical: "top",
  horizontal: "right",
};

const menuItemStyle = { color: generalWhite };

const ClientNavbar = (props: ClientNavbarProps) => {
  const { hideMenuButton, hideMidButton } = props;

  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    useState<null | HTMLElement>(null);

  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const auth = useAuth();
  const navigate = useNavigate();

  const handleMobileMenuClose = () => setMobileMoreAnchorEl(null);

  const handleMenuClose = () => handleMobileMenuClose();

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) =>
    setMobileMoreAnchorEl(event.currentTarget);

  const handleLogoutClick = () => {
    window.confirm("Tem certeza que deseja sair?") &&
      handleLogout(auth, navigate);
    handleMenuClose();
  };

  const mobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={anchorProps}
      keepMounted
      transformOrigin={anchorProps}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MobileMenuItem
        icon={<AccountCircle sx={{ color: "text.primary" }} />}
        onClick={() => navigate("/user/details")}
        label={<Typography>Meu perfil</Typography>}
      />

      <MobileMenuItem
        icon={<LuggageIcon sx={{ color: "text.primary" }} />}
        onClick={() => navigate("/checkout")}
        label={<Typography>Mala</Typography>}
      />

      <MobileMenuItem
        icon={<CalendarMonthIcon sx={{ color: "text.primary" }} />}
        onClick={() => navigate("/history")}
        label={<Typography>Histórico de excursões</Typography>}
      />

      <Divider />

      <MobileMenuItem
        icon={<LogoutIcon color="error" />}
        onClick={handleLogoutClick}
        label={<Typography color="error">Sair</Typography>}
      />
    </Menu>
  );

  return (
    <>
      <Toolbar
        sx={{
          ...sharedStyles.horizontalContent,
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "primary.main",
        }}
      >
        <Button sx={styles.logo} disableRipple>
          <div
            onClick={() =>
              navigate(
                auth.user.role === UserRole.COMERCIAL ? "/agencies" : "/home"
              )
            }
          >
            <BrandLogo
              style={{
                width: 35,
                height: 35,
              }}
              color={filteredTurismSecondary}
            />
          </div>
        </Button>

        <Box sx={{ flexGrow: 1 }} />

        {!hideMidButton && (
          <Box>
            <PrimaryButton
              label="Busca avançada"
              icon={<ManageSearchIcon />}
              onClickAction={() => navigate("/search")}
              styles={styles.advancedSearchButton}
            />
          </Box>
        )}

        <Box sx={{ flexGrow: 1 }} />

        {!hideMenuButton && (
          <>
            <Box sx={{ display: { xs: "none", md: "flex" } }}>
              <Tooltip title="Checkout">
                <MenuItem
                  icon={<LuggageIcon sx={menuItemStyle} />}
                  onClick={() => navigate("/checkout")}
                />
              </Tooltip>

              <Tooltip title="Histórico de excursões">
                <MenuItem
                  icon={<CalendarMonthIcon sx={menuItemStyle} />}
                  onClick={() => navigate("/history")}
                />
              </Tooltip>

              <Tooltip title="Minha conta">
                <MenuItem
                  icon={<AccountCircle sx={menuItemStyle} />}
                  onClick={() => navigate("/user/details")}
                />
              </Tooltip>
            </Box>

            <Box sx={{ display: { xs: "flex", md: "none" } }}>
              <MenuItem
                icon={<MoreIcon sx={menuItemStyle} />}
                onClick={handleMobileMenuOpen}
              />
            </Box>
          </>
        )}
      </Toolbar>

      {!hideMenuButton && mobileMenu}
    </>
  );
};

export default ClientNavbar;

const styles = {
  logo: {
    color: generalWhite,
    textTransform: "none",
  } as SxProps,

  advancedSearchButton: {
    backgroundColor: "secondary.main",
    color: "primary.main",
    fontWeight: "bold",
    maxHeight: "40px",

    ":hover": {
      backgroundColor: "secondary.main",
    },
  } as SxProps,
};
